import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dialog"
export default class extends Controller {
  connect() {
    this.element.showModal()
    document.body.style.overflow = "hidden"
    this.element.addEventListener("close", () => this.element.remove())
  }

  disconnect() {
    document.body.style.overflow = ""
  }
}
